import { useEffect, useState } from "react"
import { getActiveCartPersistKey, subscribeActiveCartPersistKey } from "@/store/cart/cart-tenant-isolation"
import { useCartStore } from "@/store/cart/cart-store"

/**
 * Keeps Zustand cart persist state aligned across tabs for the *active tenant key*.
 * Tenant A tabs do not consume Tenant B storage events.
 */
export function useCartPersistCrossTabSync(): void {
  const [activeKey, setActiveKey] = useState<string | null>(() => getActiveCartPersistKey())

  useEffect(() => subscribeActiveCartPersistKey(setActiveKey), [])

  useEffect(() => {
    if (!activeKey) return

    const onStorage = (event: StorageEvent) => {
      if (event.storageArea !== localStorage) return
      if (event.key !== activeKey) return
      void useCartStore.persist.rehydrate()
    }
    window.addEventListener("storage", onStorage)
    return () => window.removeEventListener("storage", onStorage)
  }, [activeKey])
}
